import * as React from "react";

export type BooleanValue = boolean | null;

export function BooleanEditor({
  value,
  onCommit,
  onCancel,
}: {
  value: BooleanValue;
  onCommit: (next: BooleanValue) => void;
  onCancel: () => void;
}) {
  const committedRef = React.useRef(false);

  const commit = React.useCallback(
    (next: boolean) => {
      if (committedRef.current) return;
      committedRef.current = true;
      onCommit(next);
    },
    [onCommit],
  );

  const cancel = React.useCallback(() => {
    if (committedRef.current) return;
    committedRef.current = true;
    onCancel();
  }, [onCancel]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      e.preventDefault();
      cancel();
    }
  };

  return (
    <div className="inline-flex gap-1" onKeyDown={handleKeyDown}>
      <button
        type="button"
        autoFocus
        aria-pressed={value === true}
        onClick={() => commit(true)}
        className="rounded border border-border px-2 py-1 text-xs hover:bg-muted aria-pressed:bg-foreground aria-pressed:text-background"
      >
        Yes
      </button>
      <button
        type="button"
        aria-pressed={value === false}
        onClick={() => commit(false)}
        className="rounded border border-border px-2 py-1 text-xs hover:bg-muted aria-pressed:bg-foreground aria-pressed:text-background"
      >
        No
      </button>
    </div>
  );
}
